/*
 * @Description: 商品筛选
 * @Author: ywj
 * @Date: 2025-02-08 11:24:32
 * @LastEditTime: 2025-04-08 10:08:31
 * @LastEditors: ywj@originqc.com
 */
import React, { useState, useEffect } from 'react'
import downIcon from './imgs/down.svg'
import upIcon from './imgs/up.svg'
import defaultIcon from './imgs/default.svg'
import { getCategory } from '@/api/home';
import './index.scss';

const sortData = [
  '综合', '最新', '销量', '价格'
]

interface IFilterProps {
  // classIdx: number|null;
  // sortIdx: number|null;
  orderBy: number;
  setOrderBy: any;
  secondId: number,//二级分类id
  setSecondId: any,
  searchName: string,
  priceSortDirection: number,
  setPriceSortDirection: (value: number) => void;
  setPageNum: any,
}
const GoodsFilter: React.FC<IFilterProps> = (props) => {
  // const [classIdx, setClassIdx] = useState<number|null>(0);
  // const [sortIdx, setSortIdx] = useState<number | null>(0);
  const [categoryData, setCategoryData] = useState<any>([]);

  const { orderBy, setOrderBy, secondId, setSecondId, searchName, priceSortDirection, setPriceSortDirection,setPageNum } = props;

  useEffect(() => {
    if (secondId) {
      handleCategory();
    } else {  //搜索空时，展示全部
      setCategoryData([]);
    }

  }, [searchName, secondId])
  const handleCategory = async () => {
    try {
      const res = await getCategory(secondId);
      if (res.success) {
        setCategoryData(res.obj.node);
      }
    } catch (error) {

    } finally {

    }
  }

  const handlePriceSortClick = () => {
    // 切换价格排序方向
    // if (isAsc) {
    //   setPriceSortDirection(2);
    // } else {
    //   setPriceSortDirection(1);
    // }
    setPriceSortDirection(priceSortDirection === 1 ? 2 : 1);
    setOrderBy(4);
    setPageNum(1);
  };

  const handleOrderBy = (index: number) => {
    setOrderBy(index + 1);
    setPriceSortDirection(0);
    setPageNum(1);
  }

  return (
    <div className='goods-filter-box'>
      <div className={`${(categoryData.length > 0 && !searchName) ? "classify-box" : "classify-box-all"}`} >
        <span className='classify-text'>分类：</span>
        {/* {categoryData.length>0&&categoryData[0]!.map((item:any,idx:number)=> {
          return ( */}
        {(categoryData.length > 0 && !searchName) ? <>
          <span className={`${categoryData[0]?.children.length === 0 ||Number(secondId) === categoryData[0].id ? 'classify-title highlight' : 'classify-title'}`} onClick={() => setSecondId(categoryData[0].id)}>{categoryData[0].name}</span>

          <span className='classify-children'>{categoryData[0]?.children.map((child: any, index: number) => {
            return (
              <span className={`${Number(secondId) === child.id ? 'highlight' : ''}`} onClick={() => setSecondId(child.id)}>{child.name}</span>
            )
          })
          }</span>
        </> : <span className='classify-title' >全部</span>}
        {/* //   )
        // })} */}
      </div>
      <div className="sort-box">
        <span className='sort-text'>排序：</span>
        <div className='sort-title-box'>
          {sortData.map((item, index) => {
            if (index === 3) {
              return (
                <span
                  key={item}
                className={`sort-title ${[4].includes(orderBy) ? 'highlight' : ''}`}
                onClick={handlePriceSortClick}
              >
                {item}
                <span 
                  className={`sort_up_down`}
                >
                  {/* 上三角形 */}
                  <span 
                    className= {`triangle-up ${priceSortDirection === 2 ? 'asc' : ''} ${priceSortDirection === 1 ? 'desc' : ''}`}
                  ></span>
                  {/* 下三角形 */}
                  <span 
                    className={`triangle-down ${priceSortDirection === 2 ? 'asc' : ''} ${priceSortDirection === 1 ? 'desc' : ''}`}
                  ></span>
                </span>
              </span>
              );
            }
            return (<React.Fragment key={item}>
              <span className={`sort-title sort-title-${index + 1} ${orderBy === index + 1 ? 'highlight' : ''}`} onClick={() => handleOrderBy(index)}>
                {item}

              </span>
            </React.Fragment>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GoodsFilter;